module.exports = __webpack_public_path__ + "dingbeauty-landing/img/x-mark.17d738be.svg";